import React from 'react';

interface IProgressBarCircularProps
{
	className?: string,
	size?: number,
	startAngle?: number,
	endAngle?: number,
	progress?: number,
	strokeWidth?: number,
	barColor?: string,
	backgroundColor?: string,
	showLabel?: boolean,
	labelStyle?: React.CSSProperties,
	percentMarkStyle?: React.CSSProperties,
}

const ProgressBarCircular = React.forwardRef((props: IProgressBarCircularProps, forwardedRef?: React.ForwardedRef<HTMLDivElement>) =>
{
	const size = props.size && !isNaN(props.size) ? props.size : 100;
	const rootRotation = (props.startAngle ?? 0) - 90; // natural angle is top
	const maxValue = (props.endAngle ?? 360) / 360 * 100;
	const strokeWidth = props.strokeWidth ?? 8;
	const center = size / 2;
	const radius = center - strokeWidth;
	const progress = Math.min(maxValue, (props.progress ?? 0) / 100 * maxValue);
	const arcLength = 2 * (Math.PI * radius);
	const arcOffset = arcLength * ((100 - progress) / 100);
	const bgArcOffset = arcLength * ((100 - maxValue) / 100);
	const barColor = props.barColor ?? '#CDCDCD';
	const backgroundColor = props.backgroundColor ?? '#757575';

	const labelStyle = Object.assign({
		color: "#CDCDCD",
		fontSize: (18 * (size / 100)) + "px",
	}, props.labelStyle);

	const percentMarkStyle = Object.assign({
		fontSize: (18 * (size / 100)) + "px",
	}, props.percentMarkStyle);

	return (
		<div className={"circularProgressBarWrapper"}
			ref={forwardedRef}
			style={{
				position: "relative",
				width: size + "px",
				height: size + "px",
			}}
		>
			<svg className={["circularProgressBarRoot", props.className].join(' ')}
				width={"100%"}
				height={"100%"}
			>
				<g
					transform-origin={`${center} ${center}`}
					transform={`rotate(${rootRotation})`}
				>
					<circle className="circularProgressBarBackground"
						cx={center}
						cy={center}
						r={radius}
						stroke={backgroundColor}
						strokeWidth={strokeWidth}
						fill={"transparent"}
						strokeDashoffset={bgArcOffset}
						strokeDasharray={arcLength}
					/>
					<circle className="circularProgressBarProgress"
						cx={center}
						cy={center}
						r={radius}
						stroke={barColor}
						strokeWidth={strokeWidth}
						fill={"transparent"}
						strokeDashoffset={arcOffset}
						strokeDasharray={arcLength}
					/>
				</g>
			</svg>
			{
				!props.showLabel ? null :
					<div className={"circularProgressBarLabelWrapper fullScreen"}>
						<div className={"circularProgressBarLabel"}
							style={labelStyle}
						>
							{Math.round(progress / maxValue * 100)}<span style={percentMarkStyle}>%</span>
						</div>
					</div>
			}
		</div>
	)
});

export default ProgressBarCircular;